module.exports = {
  "chat.end":"重新开始您的聊天对话",
  "chat.cancel":"取消",
  "chat.endall":"结束聊天",
  "chat.cookie":"此数字助理使用 cookie 来确保您获得最佳体验",
  "chat.learn":"了解更多",
  "chat.minimize":"最小化",
  "chat.hide":"关",
  "chat.hidebot.text":"关闭将使头像消失 15 分钟",
  "chat.hidebot":"关闭机器人",
  "chat.restart":"重新开始",
  "switch.language":"切换语言",
  "switch.property":"开关属性",
  "restart.converstation":"重新开始聊天",
  "chat.endtext":"您确定要结束当前聊天吗？",
  "check.availabity":"检查可用性",
  "check.availabity.submit":"提交",
  "check.availabity.cancel":"取消",
  "check.availabity.adults":"成年人 ",
  "check.availabity.children":"孩子们",
  "check.availabity.child.age":"年龄 - 儿童",
  "feedback.leave":"留下反饋信息",
  "feedback.leave.message":"请留言",
};
